import React from 'react'
import { AssignmentRuleDTO } from '@user/store/leadAssignmentRule'
import {
  DropResult,
  useDragData,
  DraggableItemWrapper,
} from '@user/utils/Draggable'
import Box from '@mui/material/Box'
import { LeadAssignmentRuleDraggableCard } from './LeadAssignmentRuleDraggableCard'

type Props = {
  onDragEnd: (result: DropResult) => void
  assignments: AssignmentRuleDTO[]
  onClick: (id?: number) => void
  onView: (id?: number) => void
}

export function DragLeadAssignmentRulesList(props: Props) {
  const { onDragEnd, assignments, onClick, onView } = props

  const { containerRef, draggingIndex, itemRefs, offsets } = useDragData({
    dataList: assignments,
    onDragEnd,
  })
  return (
    <Box mt={1.2} ref={containerRef} id="leadAssignmentRules">
      {assignments.map((row, i) => (
        <DraggableItemWrapper
          key={row.id}
          ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
          draggingIndex={draggingIndex}
          index={i}
          offsets={offsets}
          itemHeight="162px"
        >
          <LeadAssignmentRuleDraggableCard
            assignment={row}
            index={i}
            onClick={onClick}
            onView={onView}
          />
        </DraggableItemWrapper>
      ))}
    </Box>
  )
}
